<template>
  <div>
    <!-- Start Page Title -->
    <div class="page-title-area">
      <div class="d-table">
        <div class="d-table-cell">
          <div class="container">
            <h2>Kontakt</h2>
          </div>
        </div>
      </div>

      <div class="shape1"><img src="../../../assets/img/shape1.png" alt="shape"></div>
      <div class="shape2 rotateme"><img src="../../../assets/img/shape2.svg" alt="shape"></div>
      <div class="shape3"><img src="../../../assets/img/shape3.svg" alt="shape"></div>
      <div class="shape4"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
      <div class="shape5"><img src="../../../assets/img/shape5.png" alt="shape"></div>
      <div class="shape6 rotateme"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
      <div class="shape7"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
      <div class="shape8 rotateme"><img src="../../../assets/img/shape2.svg" alt="shape"></div>
    </div>
    <!-- End Page Title -->

    <!-- Start Contact Info Area -->
    <section class="contact-info-area ptb-80">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 col-md-6 col-sm-6">
            <div class="contact-info-box">
              <div class="icon">
                <feather type="info"></feather>
              </div>
              <h3>Fakturační údaje</h3>
              <p>Lindosoft s.r.o.</p>
              <p>IČ: 09680195</p>
              <p>Čujkovova 1714/21, Zábřeh, 700 30 Ostrava </p>
              <br />
              <p>Datová schránka:  a4vsc58</p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="contact-info-box">
              <div class="icon">
                <feather type="mail"></feather>
              </div>
              <h3>Elektronická pošta</h3>
              <p><a href="mailto:info@lindosoft.cz">info@lindosoft.cz</a></p>
            </div>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-6">
            <div class="contact-info-box">
              <div class="icon">
                <feather type="phone"></feather>
              </div>
              <h3>Telefon</h3>
              <p>+420 732824728</p>
            </div>
          </div>

<!--          <div class="col-lg-4 col-md-6 col-sm-6 offset-lg-0 offset-md-3 offset-sm-3">-->
<!--            <div class="contact-info-box">-->
<!--              <div class="icon">-->
<!--                <feather type="phone"></feather>-->
<!--              </div>-->
<!--              <h3>Call Here</h3>-->
<!--              <p><a href="#">+123 456 7890</a></p>-->
<!--              <p><a href="#">+241 452 4526</a></p>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </section>
    <!-- End Contact Info Area -->
  </div>
</template>

<script>
export default {
  name: 'Kontakt'
}
</script>
